import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type Activity = {
  __typename?: 'Activity';
  description?: Maybe<Scalars['String']>;
  end_date: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type Application = {
  __typename?: 'Application';
  id?: Maybe<Scalars['String']>;
  job_id?: Maybe<Scalars['String']>;
};

export type ApplicationResponse = {
  __typename?: 'ApplicationResponse';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Education = {
  __typename?: 'Education';
  current?: Maybe<Scalars['Boolean']>;
  gpa?: Maybe<Scalars['String']>;
  graduation_date?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  major?: Maybe<Scalars['String']>;
  minor?: Maybe<Scalars['String']>;
  school?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

export type EducationInput = {
  current?: InputMaybe<Scalars['Boolean']>;
  gpa?: InputMaybe<Scalars['String']>;
  graduation_date?: InputMaybe<Scalars['String']>;
  major?: InputMaybe<Scalars['String']>;
  minor?: InputMaybe<Scalars['String']>;
  school?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['String']>;
};

export type EducationResponse = {
  __typename?: 'EducationResponse';
  education?: Maybe<Education>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Experience = {
  __typename?: 'Experience';
  description?: Maybe<Scalars['String']>;
  employer?: Maybe<Scalars['String']>;
  end_date: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  is_current?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  start_date?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ExperienceInput = {
  description?: InputMaybe<Scalars['String']>;
  employer?: InputMaybe<Scalars['String']>;
  end_date?: InputMaybe<Scalars['String']>;
  is_current?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ExperienceResponse = {
  __typename?: 'ExperienceResponse';
  error?: Maybe<Scalars['String']>;
  experience?: Maybe<Experience>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type JobBoardInput = {
  career_paths?: InputMaybe<Array<Scalars['String']>>;
  category?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<Array<Scalars['String']>>;
  page?: InputMaybe<Scalars['Int']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

export type JobBoardLocations = {
  __typename?: 'JobBoardLocations';
  image_url?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type JobPost = {
  __typename?: 'JobPost';
  applicant_count?: Maybe<Scalars['Int']>;
  category?: Maybe<Scalars['String']>;
  company?: Maybe<JobPostCompany>;
  compensation: Array<Scalars['String']>;
  created_at: Scalars['String'];
  degrees?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  desired_gpa?: Maybe<Scalars['Float']>;
  external_link?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  locations?: Maybe<Array<Scalars['String']>>;
  requirements?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  title: Scalars['String'];
  types: Array<Scalars['String']>;
  updated_at: Scalars['String'];
  visa_sponsorship: Scalars['Boolean'];
};

export type JobPostCompany = {
  __typename?: 'JobPostCompany';
  bio?: Maybe<Scalars['String']>;
  education_level?: Maybe<Scalars['String']>;
  header_image?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  industries: Array<Scalars['String']>;
  interview_body?: Maybe<Scalars['String']>;
  locations: Array<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  perks: Array<Scalars['String']>;
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type JobPostCompanyMeta = {
  __typename?: 'JobPostCompanyMeta';
  id: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type JobPostMeta = {
  __typename?: 'JobPostMeta';
  category?: Maybe<Scalars['String']>;
  company?: Maybe<JobPostCompanyMeta>;
  created_at: Scalars['String'];
  expires?: Maybe<Scalars['String']>;
  full_time: Scalars['Boolean'];
  id: Scalars['String'];
  internship: Scalars['Boolean'];
  locations: Array<Scalars['String']>;
  slug: Scalars['String'];
  title: Scalars['String'];
  types: Array<Scalars['String']>;
  visa_sponsorship: Scalars['Boolean'];
};

export type JobPosts = {
  __typename?: 'JobPosts';
  jobs: Array<JobPostMeta>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  total: Scalars['Int'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addExperience?: Maybe<ExperienceResponse>;
  createApplicationForJob?: Maybe<ApplicationResponse>;
  toggleWelcomeMsg?: Maybe<ToggleResponse>;
  updateUser?: Maybe<UserResponse>;
  upsertEducation?: Maybe<EducationResponse>;
  upsertProfile?: Maybe<ProfileResponse>;
};


export type MutationAddExperienceArgs = {
  experienceData?: InputMaybe<ExperienceInput>;
};


export type MutationCreateApplicationForJobArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type MutationToggleWelcomeMsgArgs = {
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateUserArgs = {
  updateInput?: InputMaybe<UpdateUserProfileInput>;
};


export type MutationUpsertEducationArgs = {
  educationInput?: InputMaybe<EducationInput>;
};


export type MutationUpsertProfileArgs = {
  profileInput?: InputMaybe<ProfileInput>;
};

export type Profile = {
  __typename?: 'Profile';
  actively_looking?: Maybe<Scalars['Boolean']>;
  activity: Array<Maybe<Activity>>;
  availability?: Maybe<Array<Maybe<Scalars['String']>>>;
  compensation: Array<Maybe<Scalars['String']>>;
  compensation_max: Scalars['Int'];
  compensation_min: Scalars['Int'];
  currency: Scalars['String'];
  description: Scalars['String'];
  elevator_pitch_url: Scalars['String'];
  experience: Array<Maybe<Experience>>;
  full_time?: Maybe<Scalars['Boolean']>;
  hidden: Scalars['Boolean'];
  id: Scalars['String'];
  industries: Array<Maybe<Scalars['String']>>;
  internship?: Maybe<Scalars['Boolean']>;
  internship_seasons?: Maybe<Array<Maybe<Scalars['String']>>>;
  is_legal: Scalars['Boolean'];
  locations?: Maybe<Array<Maybe<Scalars['String']>>>;
  needs_visa?: Maybe<Scalars['Boolean']>;
  portfolio_link: Scalars['String'];
  responsibilities: Array<Maybe<Scalars['String']>>;
  resume: Scalars['String'];
  slug: Scalars['String'];
  small_description: Scalars['String'];
  strengths: Array<Scalars['String']>;
  tools: Array<Scalars['String']>;
  user_id: Scalars['String'];
  values: Array<Maybe<Scalars['String']>>;
  weaknesses: Array<Maybe<Scalars['String']>>;
};

export type ProfileInput = {
  actively_looking?: InputMaybe<Scalars['Boolean']>;
  availability?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  compensation?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ethnicity?: InputMaybe<Scalars['String']>;
  experience?: InputMaybe<Array<InputMaybe<ExperienceInput>>>;
  full_time?: InputMaybe<Scalars['Boolean']>;
  industries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internship?: InputMaybe<Scalars['Boolean']>;
  internship_seasons?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  is_legal?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  needs_visa?: InputMaybe<Scalars['Boolean']>;
  portfolio_link?: InputMaybe<Scalars['String']>;
  small_description?: InputMaybe<Scalars['String']>;
  strengths?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tools?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProfileResponse = {
  __typename?: 'ProfileResponse';
  profile?: Maybe<Profile>;
};

export type Query = {
  __typename?: 'Query';
  getJobBoardJobById?: Maybe<JobPost>;
  getJobBoardJobs?: Maybe<JobPosts>;
  me: User;
  profileBySlug: Profile;
};


export type QueryGetJobBoardJobByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetJobBoardJobsArgs = {
  jobBoardInput?: InputMaybe<JobBoardInput>;
};


export type QueryProfileBySlugArgs = {
  slug?: InputMaybe<Scalars['String']>;
};

export type ToggleResponse = {
  __typename?: 'ToggleResponse';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type UpdateUserProfileInput = {
  bio?: InputMaybe<Scalars['String']>;
  education?: InputMaybe<EducationInput>;
  ethnicity?: InputMaybe<Scalars['String']>;
  facebook_link?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  gitHub_link?: InputMaybe<Scalars['String']>;
  instagram_handle?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  linkedin_link?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  portfolio_link?: InputMaybe<Scalars['String']>;
  profile_url?: InputMaybe<Scalars['String']>;
  pronouns?: InputMaybe<Scalars['String']>;
  tiktok_handle?: InputMaybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  applications?: Maybe<Array<Maybe<Application>>>;
  careerPathId?: Maybe<Scalars['String']>;
  cloudflare_video_id?: Maybe<Scalars['String']>;
  education: Array<Maybe<Education>>;
  email?: Maybe<Scalars['String']>;
  ethnicity?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  profile?: Maybe<Profile>;
  pronouns?: Maybe<Scalars['String']>;
  showWelcomeMsg?: Maybe<Scalars['Boolean']>;
};

export type UserResponse = {
  __typename?: 'UserResponse';
  me?: Maybe<User>;
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'User', id?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, pronouns?: string | null, phoneNumber?: string | null, showWelcomeMsg?: boolean | null, careerPathId?: string | null, cloudflare_video_id?: string | null, ethnicity?: string | null, applications?: Array<{ __typename?: 'Application', id?: string | null, job_id?: string | null } | null> | null, education: Array<{ __typename?: 'Education', major?: string | null, minor?: string | null, school?: string | null, gpa?: string | null, current?: boolean | null, graduation_date?: string | null, id?: string | null, user_id?: string | null } | null>, profile?: { __typename?: 'Profile', compensation: Array<string | null>, compensation_max: number, compensation_min: number, currency: string, description: string, elevator_pitch_url: string, hidden: boolean, id: string, industries: Array<string | null>, is_legal: boolean, locations?: Array<string | null> | null, responsibilities: Array<string | null>, resume: string, slug: string, small_description: string, strengths: Array<string>, tools: Array<string>, user_id: string, values: Array<string | null>, weaknesses: Array<string | null>, internship?: boolean | null, internship_seasons?: Array<string | null> | null, full_time?: boolean | null, needs_visa?: boolean | null, portfolio_link: string, experience: Array<{ __typename?: 'Experience', id?: string | null, start_date?: string | null, end_date: string, title?: string | null, description?: string | null, employer?: string | null, is_current?: boolean | null, order?: number | null } | null>, activity: Array<{ __typename?: 'Activity', id?: string | null, start_date?: string | null, end_date: string, title?: string | null, description?: string | null, name?: string | null } | null> } | null } };

export type ProfileBySlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type ProfileBySlugQuery = { __typename?: 'Query', profileBySlug: { __typename?: 'Profile', compensation: Array<string | null>, compensation_max: number, compensation_min: number, currency: string, description: string, elevator_pitch_url: string, hidden: boolean, id: string, industries: Array<string | null>, is_legal: boolean, locations?: Array<string | null> | null, responsibilities: Array<string | null>, resume: string, slug: string, small_description: string, strengths: Array<string>, tools: Array<string>, user_id: string, values: Array<string | null>, weaknesses: Array<string | null>, activity: Array<{ __typename?: 'Activity', id?: string | null, start_date?: string | null, end_date: string, title?: string | null, description?: string | null, name?: string | null } | null>, experience: Array<{ __typename?: 'Experience', id?: string | null, start_date?: string | null, end_date: string, title?: string | null, description?: string | null, employer?: string | null, is_current?: boolean | null } | null> } };

export type CreateApplicationForJobMutationVariables = Exact<{
  slug: Scalars['String'];
}>;


export type CreateApplicationForJobMutation = { __typename?: 'Mutation', createApplicationForJob?: { __typename?: 'ApplicationResponse', success?: boolean | null, message?: string | null } | null };

export type ToggleWelcomeMsgMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>;
}>;


export type ToggleWelcomeMsgMutation = { __typename?: 'Mutation', toggleWelcomeMsg?: { __typename?: 'ToggleResponse', status?: string | null, message?: string | null } | null };

export type UpdateUserMutationVariables = Exact<{
  input?: InputMaybe<UpdateUserProfileInput>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'UserResponse', success: boolean, message?: string | null, me?: { __typename?: 'User', id?: string | null, profile?: { __typename?: 'Profile', slug: string } | null } | null } | null };

export type GetJobBoardJobsQueryVariables = Exact<{
  jobBoardInput?: InputMaybe<JobBoardInput>;
}>;


export type GetJobBoardJobsQuery = { __typename?: 'Query', getJobBoardJobs?: { __typename?: 'JobPosts', jobs: Array<{ __typename?: 'JobPostMeta', title: string, category?: string | null, created_at: string, expires?: string | null, full_time: boolean, id: string, internship: boolean, locations: Array<string>, slug: string, types: Array<string>, visa_sponsorship: boolean, company?: { __typename?: 'JobPostCompanyMeta', slug?: string | null, id: string, logo?: string | null, title: string } | null }> } | null };

export type GetJobBoardJobByIdQueryVariables = Exact<{
  jobId: Scalars['String'];
}>;


export type GetJobBoardJobByIdQuery = { __typename?: 'Query', getJobBoardJobById?: { __typename?: 'JobPost', applicant_count?: number | null, category?: string | null, id: string, slug: string, title: string, description?: string | null, created_at: string, updated_at: string, types: Array<string>, visa_sponsorship: boolean, requirements?: string | null, compensation: Array<string>, desired_gpa?: number | null, external_link?: string | null, degrees?: Array<string> | null, locations?: Array<string> | null, company?: { __typename?: 'JobPostCompany', id: string, slug: string, logo?: string | null, title: string, bio?: string | null, industries: Array<string>, locations: Array<string>, perks: Array<string>, interview_body?: string | null, header_image?: string | null, education_level?: string | null } | null } | null };

export type UpsertProfileMutationVariables = Exact<{
  input?: InputMaybe<ProfileInput>;
}>;


export type UpsertProfileMutation = { __typename?: 'Mutation', upsertProfile?: { __typename?: 'ProfileResponse', profile?: { __typename?: 'Profile', small_description: string } | null } | null };

export type UpsertEducationMutationVariables = Exact<{
  input?: InputMaybe<EducationInput>;
}>;


export type UpsertEducationMutation = { __typename?: 'Mutation', upsertEducation?: { __typename?: 'EducationResponse', education?: { __typename?: 'Education', id?: string | null, major?: string | null, minor?: string | null, school?: string | null, gpa?: string | null, current?: boolean | null, graduation_date?: string | null, user_id?: string | null } | null } | null };

export type AddExperienceMutationVariables = Exact<{
  input?: InputMaybe<ExperienceInput>;
}>;


export type AddExperienceMutation = { __typename?: 'Mutation', addExperience?: { __typename?: 'ExperienceResponse', experience?: { __typename?: 'Experience', id?: string | null, start_date?: string | null, end_date: string, title?: string | null, description?: string | null, employer?: string | null, is_current?: boolean | null } | null } | null };


export const MeDocument = gql`
    query Me {
  me {
    id
    email
    first_name
    last_name
    pronouns
    phoneNumber
    showWelcomeMsg
    careerPathId
    cloudflare_video_id
    ethnicity
    applications {
      id
      job_id
    }
    education {
      major
      minor
      school
      gpa
      current
      graduation_date
      id
      user_id
    }
    profile {
      compensation
      compensation_max
      compensation_min
      currency
      description
      elevator_pitch_url
      hidden
      id
      industries
      is_legal
      locations
      responsibilities
      resume
      slug
      small_description
      strengths
      tools
      user_id
      values
      weaknesses
      internship
      internship_seasons
      full_time
      needs_visa
      experience {
        id
        start_date
        end_date
        title
        description
        employer
        is_current
        order
      }
      activity {
        id
        start_date
        end_date
        title
        description
        name
      }
      portfolio_link
    }
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const ProfileBySlugDocument = gql`
    query ProfileBySlug($slug: String) {
  profileBySlug(slug: $slug) {
    compensation
    compensation_max
    compensation_min
    currency
    description
    elevator_pitch_url
    hidden
    id
    industries
    is_legal
    locations
    responsibilities
    resume
    slug
    small_description
    strengths
    tools
    user_id
    values
    weaknesses
    activity {
      id
      start_date
      end_date
      title
      description
      name
    }
    experience {
      id
      start_date
      end_date
      title
      description
      employer
      is_current
    }
  }
}
    `;

/**
 * __useProfileBySlugQuery__
 *
 * To run a query within a React component, call `useProfileBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useProfileBySlugQuery(baseOptions?: Apollo.QueryHookOptions<ProfileBySlugQuery, ProfileBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileBySlugQuery, ProfileBySlugQueryVariables>(ProfileBySlugDocument, options);
      }
export function useProfileBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileBySlugQuery, ProfileBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileBySlugQuery, ProfileBySlugQueryVariables>(ProfileBySlugDocument, options);
        }
export type ProfileBySlugQueryHookResult = ReturnType<typeof useProfileBySlugQuery>;
export type ProfileBySlugLazyQueryHookResult = ReturnType<typeof useProfileBySlugLazyQuery>;
export type ProfileBySlugQueryResult = Apollo.QueryResult<ProfileBySlugQuery, ProfileBySlugQueryVariables>;
export const CreateApplicationForJobDocument = gql`
    mutation createApplicationForJob($slug: String!) {
  createApplicationForJob(slug: $slug) {
    success
    message
  }
}
    `;
export type CreateApplicationForJobMutationFn = Apollo.MutationFunction<CreateApplicationForJobMutation, CreateApplicationForJobMutationVariables>;

/**
 * __useCreateApplicationForJobMutation__
 *
 * To run a mutation, you first call `useCreateApplicationForJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApplicationForJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApplicationForJobMutation, { data, loading, error }] = useCreateApplicationForJobMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useCreateApplicationForJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateApplicationForJobMutation, CreateApplicationForJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApplicationForJobMutation, CreateApplicationForJobMutationVariables>(CreateApplicationForJobDocument, options);
      }
export type CreateApplicationForJobMutationHookResult = ReturnType<typeof useCreateApplicationForJobMutation>;
export type CreateApplicationForJobMutationResult = Apollo.MutationResult<CreateApplicationForJobMutation>;
export type CreateApplicationForJobMutationOptions = Apollo.BaseMutationOptions<CreateApplicationForJobMutation, CreateApplicationForJobMutationVariables>;
export const ToggleWelcomeMsgDocument = gql`
    mutation ToggleWelcomeMsg($userId: String) {
  toggleWelcomeMsg(userId: $userId) {
    status
    message
  }
}
    `;
export type ToggleWelcomeMsgMutationFn = Apollo.MutationFunction<ToggleWelcomeMsgMutation, ToggleWelcomeMsgMutationVariables>;

/**
 * __useToggleWelcomeMsgMutation__
 *
 * To run a mutation, you first call `useToggleWelcomeMsgMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleWelcomeMsgMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleWelcomeMsgMutation, { data, loading, error }] = useToggleWelcomeMsgMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useToggleWelcomeMsgMutation(baseOptions?: Apollo.MutationHookOptions<ToggleWelcomeMsgMutation, ToggleWelcomeMsgMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleWelcomeMsgMutation, ToggleWelcomeMsgMutationVariables>(ToggleWelcomeMsgDocument, options);
      }
export type ToggleWelcomeMsgMutationHookResult = ReturnType<typeof useToggleWelcomeMsgMutation>;
export type ToggleWelcomeMsgMutationResult = Apollo.MutationResult<ToggleWelcomeMsgMutation>;
export type ToggleWelcomeMsgMutationOptions = Apollo.BaseMutationOptions<ToggleWelcomeMsgMutation, ToggleWelcomeMsgMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: UpdateUserProfileInput) {
  updateUser(updateInput: $input) {
    success
    message
    me {
      id
      profile {
        slug
      }
    }
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const GetJobBoardJobsDocument = gql`
    query GetJobBoardJobs($jobBoardInput: JobBoardInput) {
  getJobBoardJobs(jobBoardInput: $jobBoardInput) {
    jobs {
      title
      category
      company {
        slug
        id
        logo
        title
      }
      created_at
      expires
      full_time
      id
      internship
      locations
      slug
      types
      visa_sponsorship
    }
  }
}
    `;

/**
 * __useGetJobBoardJobsQuery__
 *
 * To run a query within a React component, call `useGetJobBoardJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobBoardJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobBoardJobsQuery({
 *   variables: {
 *      jobBoardInput: // value for 'jobBoardInput'
 *   },
 * });
 */
export function useGetJobBoardJobsQuery(baseOptions?: Apollo.QueryHookOptions<GetJobBoardJobsQuery, GetJobBoardJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobBoardJobsQuery, GetJobBoardJobsQueryVariables>(GetJobBoardJobsDocument, options);
      }
export function useGetJobBoardJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobBoardJobsQuery, GetJobBoardJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobBoardJobsQuery, GetJobBoardJobsQueryVariables>(GetJobBoardJobsDocument, options);
        }
export type GetJobBoardJobsQueryHookResult = ReturnType<typeof useGetJobBoardJobsQuery>;
export type GetJobBoardJobsLazyQueryHookResult = ReturnType<typeof useGetJobBoardJobsLazyQuery>;
export type GetJobBoardJobsQueryResult = Apollo.QueryResult<GetJobBoardJobsQuery, GetJobBoardJobsQueryVariables>;
export const GetJobBoardJobByIdDocument = gql`
    query GetJobBoardJobById($jobId: String!) {
  getJobBoardJobById(id: $jobId) {
    applicant_count
    category
    company {
      id
      slug
      logo
      title
      bio
      industries
      locations
      perks
      interview_body
      header_image
      education_level
    }
    id
    slug
    title
    description
    created_at
    updated_at
    types
    visa_sponsorship
    requirements
    compensation
    desired_gpa
    external_link
    degrees
    locations
  }
}
    `;

/**
 * __useGetJobBoardJobByIdQuery__
 *
 * To run a query within a React component, call `useGetJobBoardJobByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobBoardJobByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobBoardJobByIdQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useGetJobBoardJobByIdQuery(baseOptions: Apollo.QueryHookOptions<GetJobBoardJobByIdQuery, GetJobBoardJobByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobBoardJobByIdQuery, GetJobBoardJobByIdQueryVariables>(GetJobBoardJobByIdDocument, options);
      }
export function useGetJobBoardJobByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobBoardJobByIdQuery, GetJobBoardJobByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobBoardJobByIdQuery, GetJobBoardJobByIdQueryVariables>(GetJobBoardJobByIdDocument, options);
        }
export type GetJobBoardJobByIdQueryHookResult = ReturnType<typeof useGetJobBoardJobByIdQuery>;
export type GetJobBoardJobByIdLazyQueryHookResult = ReturnType<typeof useGetJobBoardJobByIdLazyQuery>;
export type GetJobBoardJobByIdQueryResult = Apollo.QueryResult<GetJobBoardJobByIdQuery, GetJobBoardJobByIdQueryVariables>;
export const UpsertProfileDocument = gql`
    mutation UpsertProfile($input: ProfileInput) {
  upsertProfile(profileInput: $input) {
    profile {
      small_description
    }
  }
}
    `;
export type UpsertProfileMutationFn = Apollo.MutationFunction<UpsertProfileMutation, UpsertProfileMutationVariables>;

/**
 * __useUpsertProfileMutation__
 *
 * To run a mutation, you first call `useUpsertProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertProfileMutation, { data, loading, error }] = useUpsertProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpsertProfileMutation, UpsertProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertProfileMutation, UpsertProfileMutationVariables>(UpsertProfileDocument, options);
      }
export type UpsertProfileMutationHookResult = ReturnType<typeof useUpsertProfileMutation>;
export type UpsertProfileMutationResult = Apollo.MutationResult<UpsertProfileMutation>;
export type UpsertProfileMutationOptions = Apollo.BaseMutationOptions<UpsertProfileMutation, UpsertProfileMutationVariables>;
export const UpsertEducationDocument = gql`
    mutation UpsertEducation($input: EducationInput) {
  upsertEducation(educationInput: $input) {
    education {
      id
      major
      minor
      school
      gpa
      current
      graduation_date
      user_id
    }
  }
}
    `;
export type UpsertEducationMutationFn = Apollo.MutationFunction<UpsertEducationMutation, UpsertEducationMutationVariables>;

/**
 * __useUpsertEducationMutation__
 *
 * To run a mutation, you first call `useUpsertEducationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertEducationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertEducationMutation, { data, loading, error }] = useUpsertEducationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertEducationMutation(baseOptions?: Apollo.MutationHookOptions<UpsertEducationMutation, UpsertEducationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertEducationMutation, UpsertEducationMutationVariables>(UpsertEducationDocument, options);
      }
export type UpsertEducationMutationHookResult = ReturnType<typeof useUpsertEducationMutation>;
export type UpsertEducationMutationResult = Apollo.MutationResult<UpsertEducationMutation>;
export type UpsertEducationMutationOptions = Apollo.BaseMutationOptions<UpsertEducationMutation, UpsertEducationMutationVariables>;
export const AddExperienceDocument = gql`
    mutation addExperience($input: ExperienceInput) {
  addExperience(experienceData: $input) {
    experience {
      id
      start_date
      end_date
      title
      description
      employer
      is_current
    }
  }
}
    `;
export type AddExperienceMutationFn = Apollo.MutationFunction<AddExperienceMutation, AddExperienceMutationVariables>;

/**
 * __useAddExperienceMutation__
 *
 * To run a mutation, you first call `useAddExperienceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddExperienceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addExperienceMutation, { data, loading, error }] = useAddExperienceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddExperienceMutation(baseOptions?: Apollo.MutationHookOptions<AddExperienceMutation, AddExperienceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddExperienceMutation, AddExperienceMutationVariables>(AddExperienceDocument, options);
      }
export type AddExperienceMutationHookResult = ReturnType<typeof useAddExperienceMutation>;
export type AddExperienceMutationResult = Apollo.MutationResult<AddExperienceMutation>;
export type AddExperienceMutationOptions = Apollo.BaseMutationOptions<AddExperienceMutation, AddExperienceMutationVariables>;